// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// T12/T13 Feature-Screen-Texte (Heute, Plan, Rezept, Vorrat, Einkaufen) in der
// gleichen informellen "du"-Stimme wie der Rest der App.
export const viewsDe = {
    slots: {
        breakfast: "Frühstück",
        morning_snack: "Vormittagssnack",
        lunch: "Mittagessen",
        afternoon_snack: "Nachmittagssnack",
        dinner: "Abendessen",
        snack: "Snack",
    },
    today: {
        eatenEyebrow: "Heute gegessen",
        whyLabel: "Warum?",
        nextEyebrow: "Als Nächstes",
        stillOpenEyebrow: "Noch offen",
        dayHeaderNext: "{{eaten}} kcal gegessen · {{slot}} kommt als Nächstes",
        dayHeaderStillOpen: "{{eaten}} kcal gegessen · {{slot}} ist noch offen",
        timelineDone: "Erledigt",
        allLoggedTitle: "Für heute ist alles erfasst.",
        allLoggedBody: "Die Mahlzeiten von morgen stehen im Plan.",
        allLoggedKcalSummary: "{{eaten}} / {{target}} kcal heute",
        allLoggedKcalSummaryNoTarget: "{{eaten}} kcal heute",
        projectedWord: "Prognose",
        targetWord: "Ziel",
        plannedWord: "geplant",
        thread: { dayLabel: "Heute" },
        streakChip: "{{days}}-Tage-Serie",
        clarifyLine: "Eine Frage zu deinen Essensregeln: Milchallergie oder Laktoseintoleranz?",
        clarifyLevelLine: "Eine Frage zu deiner Laktoseintoleranz: wie streng ist sie?",
        clarifyCta: "Unter Essen & Gesundheit beantworten",
        loggedChip: "{{done}}/{{planned}} Mahlzeiten diese Woche erfasst",
        greetingMorning: "Guten Morgen",
        greetingAfternoon: "Guten Tag",
        greetingEvening: "Guten Abend",
        subtitleDefault: "Das steht heute auf deinem Plan.",
        subtitleReason: "Heutige Auswahl: {{reason}}.",
        noMealsTitle: "Für heute nichts geplant",
        noMealsBody: "Dein aktueller Plan deckt das heutige Datum nicht ab. Öffne Plan, um die ganze Woche zu sehen.",
        viewPlanCta: "Plan ansehen",
        targetBarLabel: "Tagesziel",
        ringEaten: "GEGESSEN",
        ringPlanned: "GEPLANT",
        heroProjected: "Prognose heute: {{projected}} / {{target}}",
        backfillTitle: "Wie lief gestern wirklich?",
        backfillReview: "Prüfen",
        backfillBody: "{{count}} Mahlzeiten von gestern sind noch nicht eingetragen.",
        backfillAllPlanned: "Alles wie geplant gegessen",
        backfillChanged: "Es lief anders — Amy erzählen",
        backfillChangedPrompt: "Gestern lief es nicht ganz nach Plan — das war anders: ",
        backfillDismiss: "So lassen",
        backfillDone: "Gestern ist eingetragen.",
        targetBarWithinRange: "Innerhalb deines Zielbereichs",
        ledgerEaten: "Bisher gegessen",
        ledgerProjected: "Heute voraussichtlich",
        ledgerFits: "{{kcal}} kcal Spielraum zusätzlich zu deinem Plan",
        ledgerOverProjection: "Voraussichtlich {{delta}} kcal über dem Ziel — bitte Amy ums Ausbalancieren",
        ledgerDinnerAtRisk: "Achtung: Der Tag füllt sich früh — fürs Abendessen bliebe sehr wenig übrig.",
        ledgerLoggedTitle: "Außerplanmäßig erfasst",
        ledgerDeleteLabel: "Eintrag entfernen",
        targetBarOverRange: "Über deinem Zielbereich",
        targetBarUnderRange: "Unter deinem Zielbereich",
        targetBarNoTarget: "Kein Kalorienziel festgelegt",
        targetBarEatenTag: "gegessen",
        targetBarPlannedToday: "Für heute geplant: {{kcal}}",
        dayBelowFloorTitle: "Heute liegt unter deinem Minimum",
        dayBelowFloorBody: "Aktuell kommt heute auf etwa {{projected}} kcal, {{deficit}} kcal unter deinem Minimum von {{floor}} kcal. Amy kann den Rest des Tages behutsam ausgleichen — nichts muss erzwungen werden.",
        dayBelowFloorCta: "Mit Amy ausgleichen",
        dayBelowFloorPrompt: "Heute liegt meine Prognose unter meinem sicheren Minimum — kannst du mir helfen, den Rest des Tages auszugleichen?",
        dayOnTarget: "Heute liegst du genau auf deinem Ziel.",
        projectionLower: "Weniger als ursprünglich geplant ({{planned}} kcal), weil {{reasons}}.",
        projectionHigher: "Mehr als ursprünglich geplant ({{planned}} kcal), weil {{reasons}}.",
        projectionReasonPartial: "du {{slot}} nur teilweise gegessen hast",
        projectionReasonSkipped: "du {{slot}} nicht gegessen hast",
        projectionReasonChanged: "du {{slot}} geändert hast",
        projectionReasonHad: "du bei {{slot}} eine andere Menge gegessen hast",
        projectionReasonOffPlan: "du außerplanmäßig etwas erfasst hast",
        projectionReasonJoin: " und ",
    },
    valueCard: {
        title: "Dein bisheriger Nutzen",
        realizedLabel: "Realisiert (aus bestätigten Ergebnissen)",
        projectedLabel: "Geplant (aus dieser Wochenplanung)",
        adherenceLabel: "{{recorded}} von {{planned}} Mahlzeiten erfasst",
        headlineClause: "Bisher gespart, aus den {{recorded}} von {{planned}} Mahlzeiten, die du diese Woche festgehalten hast.",
        emptyTitle: "Erfasse Ergebnisse, um deinen Fortschritt zu sehen",
        emptyBody: "Markiere Mahlzeiten als gegessen, teilweise gegessen, nicht gegessen oder geändert — dann erscheint hier deine realisierte Ersparnis. Wir zeigen niemals 0 € als Fakt, nur was wirklich bestätigt ist.",
        byKindHeading: "Woraus sie entstand",
        byKindPantryReuse: "Aus deiner Küche",
        byKindOffer: "Angebote im Handel",
    },
    mealCard: {
        had: "Gegessen",
        other: "Anderes",
        status: { had: "Erfasst", partial: "Erfasst · teilweise", skipped: "Nicht gegessen", changed: "Geändert" },
        macroLine: "Eiweiß {{p}} g · Kohlenhydrate {{c}} g · Fett {{f}} g",
        openRecipe: "Rezept öffnen",
        changedNote: "Du hast diese Mahlzeit geändert.",
        swap: "Tauschen",
        lock: "Sperren",
        unlock: "Entsperren",
        markOutcome: "Ergebnis markieren",
        moreActions: "Optionen",
        moreShort: "Mehr",
        moreHint: "Gericht tauschen oder Ergebnis markieren",
        swapDish: "Gericht tauschen",
        swapDishHint: "Zeigt andere Gerichte, die zu diesem Slot passen",
        loggedAs: "Eingetragen: {{outcome}}",
        partialDetail: "{{consumed}} von {{planned}} gezählt",
        insteadOf: "Statt {{meal}}",
        logCta: "Eintragen",
        logOutcomeHint: "Ergebnis eintragen",
        changeOutcome: "Ändern",
        lockedBadge: "Gesperrt",
        batchBadge: "Vorgekocht",
        pantryBadge: "Aus deiner Küche",
        activeTime: "{{minutes}} Min. aktiv am Herd",
        minutesShort: "{{minutes}} Min",
        minutesActiveTotal: "{{active}} Min aktiv · {{total}} gesamt",
        totalTime: "{{minutes}} Min. gesamt",
        perServing: "pro Portion",
    },
    reasonBadges: {
        VEGAN_MATCH: "Vegan passend",
        NUT_FREE: "Nussfrei",
        TIME_FIT: "Passt in dein Zeitbudget",
        PANTRY_REUSE: "Nutzt, was du hast",
        LOWER_COST: "Günstiger",
        OFFER_MATCH: "Im Angebot",
    },
    outcomeSheet: {
        howMuch: "Wie viel davon?",
        notCounted: "Nicht gezählt",
        allOfIt: "Alles",
        counted: "werden gezählt",
        log: "Erfassen",
        title: "Wie war diese Mahlzeit?",
        had: "Gegessen",
        partial: "Teilweise gegessen",
        partialAmountQuestion: "Wie viel davon hast du gegessen?",
        skipped: "Nicht gegessen",
        changed: "Geändert",
        submit: "Ergebnis speichern",
        submitting: "Speichert…",
        success: "Ergebnis gespeichert.",
        error: "Wir konnten dieses Ergebnis nicht speichern. Diese Funktion ist auf diesem Server eventuell noch nicht verfügbar — bitte versuche es später erneut.",
        close: "Schließen",
        pantryUpdated: "Küche aktualisiert — {{count}} Zutat(en) abgezogen.",
        pantryRestored: "Küche aktualisiert — {{count}} Zutat(en) zurückgelegt.",
        pantryHint: "Markierte Mahlzeiten halten Küche und Einkaufsliste aktuell — BiteBalance plant mit dem, was du wirklich hast.",
        pantryHintLink: "Zur Küche",
        changedWhatInstead: "Was hattest du stattdessen?",
        changedLogWithAmy: "Mit Amy eintragen",
        changedSkip: "Ohne Details — nur als geändert markieren",
        changedBeta: "Beta — Amy schätzt das gemeinsam mit dir.",
        changedAmyPrefill: "Ich hatte {{food}} statt {{meal}} ({{slot}}, {{date}}). Bitte trag es ein.",
    },
    plan: {
        budgetConflictNotice: "Diese Änderung bringt die Woche etwa {{over}} über dein Wochenbudget von {{budget}}.",
        budgetConflictAccept: "Budget-Überschreitung für diese Woche erlauben",
        budgetInfeasibleTitle: "Noch kein Plan innerhalb deines Budgets",
        budgetInfeasibleBody: "Wir konnten keine gültige Woche innerhalb von {{budget}} bauen — die günstigste gültige Version kostet {{cheapest}} ({{gap}} darüber). Dein aktueller Plan bleibt unverändert. Frag Amy nach Optionen oder passe das Budget in den Einstellungen an.",
        settingsDriftTitle: "Diese Woche wurde für {{planTarget}} kcal pro Tag geplant",
        settingsDriftBody: "Dein Tagesziel liegt jetzt bei {{currentTarget}} kcal. Du kannst der Woche weiter folgen und einzelne Mahlzeiten ändern — jede geänderte Mahlzeit wird an dein neues Ziel angepasst. Oder bitte Amy, die Woche zu überarbeiten.",
        weekTitle: "Deine Woche",
        // Fresh Adaptive Plan (ADR-068, mobile)
        mealsCount: "{{count}} Mahlzeiten",
        pricesEstimated: "≈ Preise sind Schätzwerte.",
        mealsCountOne: "1 Mahlzeit",
        goToDay: "Zu {{day}}",
        adaptedPill: "Angepasst",
        adaptedAnnounce: "Plan angepasst: {{day}}",
        generatingEyebrow: "Deine Woche entsteht",
        generatingTitle: "Einen Moment — BiteBalance plant um dich herum.",
        viewDay: "Tag",
        viewWeek: "Woche",
        viewToggleLabel: "Plan-Ansicht",
        todayMarker: "Heute",
        dailyMode: "Täglich kochen",
        batchMode: "Vorkochen",
        hybridMode: "Beides kombinieren",
        lockedLabel: "Gesperrt — bleibt bei Neuberechnung erhalten",
        batchSectionTitle: "Vorkochen diese Woche",
        batchCardTitle: "Vorgekocht: {{title}}",
        portionsSupplied: "{{count}} Portionen, einmal gekocht",
        // ADR-065 Prepared Food Inventory: cooked portions, never inferred from the plan.
        preparedSectionTitle: "Schon gekocht",
        preparedEmpty: "Noch nichts vorgekocht. Markiere eine Portion als vorgekocht, sobald du sie gekocht hast.",
        preparedPortionsLeft: "{{remaining}} von {{prepared}} Portionen übrig",
        preparedAllEaten: "Alle {{prepared}} Portionen gegessen",
        preparedOn: "Gekocht am {{date}}",
        markPrepared: "Als vorgekocht markieren",
        markPreparedHint: "Bestätige erst, wenn du wirklich gekocht hast. Wir nehmen die Zutaten aus deiner Küche und führen die Portionen hier.",
        markPreparedBusy: "Wird gespeichert…",
        preparedKeepsNote: "Auswärts essen oder eine nicht gegessene Mahlzeit verbraucht keine Portion — sie bleibt hier, bis du sie isst.",
        preparedUncovered: "Nicht alles war in deiner Küche: {{items}} kam von woanders, dafür wurde nichts abgezogen.",
        preparedError: "Das konnten wir nicht speichern. Bitte versuche es erneut.",
        preparedPortionEaten: "{{remaining}} Portionen übrig",
        undoButton: "Letzte Änderung rückgängig machen",
        undoing: "Wird rückgängig gemacht…",
        undoSuccess: "Änderung rückgängig gemacht. Dein Plan ist wie zuvor.",
        undoError: "Wir konnten das nicht rückgängig machen. Bitte lade neu und versuche es erneut.",
        staleReloadTitle: "Dieser Plan hat sich anderswo geändert",
        staleReloadBody: "Jemand (oder etwas) hat deinen Plan aktualisiert, seit diese Seite geladen wurde. Lade neu, um die aktuelle Version zu sehen, bevor du es erneut versuchst.",
        reloadButton: "Neu laden",
        generating: "Deine Woche wird erstellt — das dauert ein paar Sekunden…",
        generateButton: "Meinen Plan erstellen",
        noPlanYetBody: "Wir konnten keinen Plan für dich laden. Falls dein erster Plan nicht erstellt wurde (z. B. weil eine Profilangabe fehlte), kannst du ihn hier starten.",
        warningsTitle: "Hinweis zur Nährstoffbilanz dieser Woche",
        warningMacroBand: "An {{count}} Tag(en) liegen Eiweiß, Kohlenhydrate oder Fett außerhalb des üblichen ±15%-Bereichs. Kalorien und deine Sicherheitsgrenzen stimmen weiterhin — das ist ein Ernährungshinweis, kein Sicherheitsproblem.",
        warningNearBoundary: "Einige Tage liegen nahe am Rand deiner Tageszielbereiche. Kleine Änderungen (z. B. ein Gerichtetausch) könnten sie darüber hinaus verschieben.",
        warningGeneric: "Einige Tage tragen einen Ernährungshinweis. Alle Sicherheitsprüfungen wurden bestanden.",
        regenFailedTitle: "Dieser Plan passt evtl. nicht mehr zu deinen Einstellungen",
        regenFailedBody: "Die letzte Neuberechnung war nicht erfolgreich — dein vorheriger Plan wird weiter angezeigt.",
        regenCta: "Plan neu berechnen",
        // P1 (founder-reported, 2026-09-22): ein echter Plan, dessen Woche zu
        // Ende ist — anders als "nichts geplant" (nie ein Plan/Revision vorhanden).
        // Calm Timeline (2026-09-23): weekEndedBody an die vom Gründer freigegebene Formulierung angepasst.
        weekEndedTitle: "Deine Woche ist abgeschlossen",
        weekEndedBody: "Bereit für die nächste?",
        weekEndedCta: "Nächste 7 Tage planen",
        weekEndedViewLastWeek: "Letzte Woche ansehen",
        budgetInfeasibleAdjustCta: "Budget anpassen",
        budgetInfeasibleKeepNote: "Du kannst auch deinen aktuellen Plan behalten und später entscheiden.",
        conflictsTitle: "Dein Plan braucht ein kleines Update",
        conflictsBodyOne: "1 Mahlzeit enthält ein Lebensmittel, das du nicht essen möchtest. Wir können sie für dich ersetzen.",
        conflictsBodyOther: "{{count}} Mahlzeiten enthalten Lebensmittel, die du nicht essen möchtest. Wir können sie für dich ersetzen.",
        conflictsReplaceCta: "Meinen Plan aktualisieren",
        conflictsEditCta: "Essensvorlieben bearbeiten",
        conflictsPreviewTitle: "Vorgeschlagene Alternativen",
        conflictsApproveCta: "Diese Mahlzeiten übernehmen",
        conflictsApplied: "Erledigt — dein Plan und deine Einkaufsliste sind aktualisiert.",
        conflictsError: "Wir konnten gerade keine Alternativen vorbereiten. Die betroffenen Mahlzeiten bleiben markiert, damit du sie selbst tauschen kannst.",
        conflictsMealBadge: "Enthält ein Lebensmittel, das du meidest",
    },
    proposal: {
        title: "Änderung prüfen",
        changesTitle: "Was sich ändern würde",
        beforeLabel: "Vorher",
        afterLabel: "Nachher",
        kcalDeltaLabel: "Kalorien",
        timeDeltaLabel: "Zeit",
        costDeltaLabel: "Kosten",
        shoppingDeltaLabel: "Einkaufsliste",
        approve: "Bestätigen",
        approving: "Wird angewendet…",
        revise: "Überarbeiten",
        lockChange: "{{title}} wird fixiert — Tausch und Neuaufbau lassen es unangetastet.",
        unlockChange: "{{title}} wird wieder freigegeben — Tausch und Neuaufbau dürfen es ändern.",
        lockApprove: "Fixieren",
        unlockApprove: "Freigeben",
        timeDeltaHint: "aktive Kochzeit",
        shoppingDeltaHint: "deine Einkaufsliste",
        noImpactHint: "Keine Änderung an Kochzeit oder Einkaufsliste.",
        cancel: "Abbrechen",
        applySuccess: "Angewendet. Dein Plan wurde aktualisiert.",
        tryAnother: "Andere Änderung versuchen",
        failTitle: "Diese Änderung ist nicht sicher anwendbar",
        loading: "Änderung wird geprüft…",
        error: "Wir konnten diese Änderung nicht prüfen. Bitte versuche es erneut.",
        offerProvenance: "{{retailer}}: {{price}} bis {{date}} — Kann je nach Markt abweichen (Quelle: {{source}})",
        noCheaperFound: "Nichts Günstigeres gefunden diese Woche.",
        makeRoomInfeasible: "Selbst die leichteste Variante deiner anderen Mahlzeiten heute schafft für diese Portion keinen Platz.",
        noFitFound: "Keine kleinere Portion dieser Mahlzeit und keine andere Option für diesen Slot bringt deinen Tag in deinen Bereich und über dein Minimum.",
        offerExpired: "Das Angebot ist abgelaufen — bitte neu vorschlagen lassen.",
        candidatesTitle: "Ersatz wählen",
        candidatesIntro: "Gerichte, die zu diesem Slot und deinen Ernährungsregeln passen — das beste zuerst.",
        candidatesNone: "Gerade passt kein anderes Gericht in diesen Slot.",
        candidatesLoading: "Gerichte werden gesucht…",
        candidatesChoose: "{{title}} prüfen",
        candidatesBack: "Andere Gerichte",
        candidatesPlanned: "Geplant",
        noFitWithinTime: "Kein anderes Gericht für diesen Slot braucht höchstens {{max}} Minuten. Das schnellste braucht {{fastest}} Minuten.",
        noFitWithinTimeNoFigure: "Kein anderes Gericht für diesen Slot passt in diese Zeit.",
    },
    validationReasons: {
        ALLERGEN_CONFLICT: "Das würde eine Zutat einführen, die im Konflikt mit einer deiner Allergien oder Unverträglichkeiten steht.",
        HARD_EXCLUSION: "Das würde etwas enthalten, das du nie serviert bekommen möchtest.",
        MISSING_COMPOSITION: "Für diese Option liegen noch keine vollständigen Zutatendaten vor, daher können wir die Sicherheit nicht bestätigen.",
        NUTRITION_OUT_OF_RANGE: "Das würde die heutigen Nährwerte außerhalb deines Zielbereichs bringen.",
        TIME_LIMIT_EXCEEDED: "Das würde länger dauern als deine verfügbare Kochzeit.",
        BATCH_YIELD_MISMATCH: "Das würde nicht die richtige Anzahl an vorgekochten Portionen ergeben.",
        generic: "Diese Änderung hat unsere Sicherheits- und Nährwertprüfung nicht bestanden.",
    },
    recipe: {
        back: "Zurück zum Plan",
        notYetLoggedLabel: "Noch nicht protokolliert",
        servingsLabel: "Deine Portion",
        plannedPortionLabel: "Deine geplante Portion",
        batchPortionsFixed: "Diese Mahlzeit gehört zu einem Gericht, das einmal für mehrere Abendessen vorgekocht wird. Ihre Portion lässt sich deshalb nicht einzeln ändern.",
        servingsValue: "{{servings}} Portionen",
        servingsValueOne: "1 Portion",
        portionNutritionLabel: "Für deine Portion",
        baseServingLabel: "Eine Rezeptportion",
        recipeMakes: "Das Rezept ergibt {{count}} Portionen",
        ingredientsForPortion: "Zutaten für deine Portion ({{servings}} Portionen)",
        ingredientsForPortionOne: "Zutaten für deine Portion (1 Portion)",
        stepperMin: "Kleinste Portion",
        stepperMax: "Größte Portion",
        activeTimeLabel: "Aktive Zeit",
        totalTimeLabel: "Gesamtzeit",
        costLabel: "Geschätzte Kosten pro Portion",
        ingredientsTitle: "Zutaten",
        ingredientsGap: "Eine detaillierte Zutatenliste ist für diese Mahlzeit vom Rezeptdienst noch nicht verfügbar. Das ist eine bekannte Lücke im aktuellen Stand, kein fehlendes Rezept — wir zeigen hier nur echte Daten, niemals eine Platzhalterliste.",
        allergensTitle: "Allergene",
        allergensGap: "Quellenbasierte Allergendaten für dieses konkrete Rezept sind hier noch nicht verfügbar.",
        allergensDisclaimer: "Prüfe immer die Produktetiketten — Quellendaten können unvollständig sein, und deine Sicherheit geht vor.",
        allergenResponsibility: "Allergen-Angaben stammen aus unseren geprüften Zutatendaten. Rezepturen und Kreuzkontakt können abweichen — prüfe immer die Verpackung und bestätige selbst, dass jede Mahlzeit für dich sicher ist, bevor du sie kochst oder isst.",
        yourAllergenFlag: "Von dir angegebenes Allergen",
        yourIntoleranceFlagFreeOk: "Enthält Milchprodukte — dein Plan verwendet nur laktosefreie",
        yourIntoleranceFlagAvoidAll: "Deine Einstellung: keine Milchprodukte",
        stepsTitle: "Zubereitung",
        stepsGap: "Eine Schritt-für-Schritt-Anleitung ist für diese Mahlzeit vom Rezeptdienst noch nicht verfügbar.",
        provenanceAmy: "Von Amy zusammengestellt — auf Basis unserer geprüften Zutatendaten",
        recalcTitle: "Portionen: {{from}} → {{to}}",
        recalcNote: "Nährwerte und Kosten passen sich der Portionsgröße an.",
        recalcRequest: "Wird aktualisiert…",
        recalcApplied: "Das ist eine Vorschau — nichts ändert sich, bis du sie übernimmst.",
        recalcError: "Wir konnten die Portionsgröße nicht aktualisieren. Bitte versuche es erneut.",
        previewPendingTitle: "Wird auf {{servings}} aktualisiert …",
        previewFailedTitle: "Aktualisierung auf {{servings}} fehlgeschlagen",
        previewTitle: "Vorschau: {{servings}} Portionen",
        previewTitleOne: "Vorschau: 1 Portion",
        previewIngredientsTitle: "Zutaten für {{servings}} Portionen (Vorschau)",
        previewIngredientsTitleOne: "Zutaten für 1 Portion (Vorschau)",
        previewApply: "{{servings}} Portionen übernehmen",
        previewApplyOne: "1 Portion übernehmen",
        previewCancel: "Bei {{servings}} Portionen bleiben",
        previewCancelOne: "Bei 1 Portion bleiben",
        previewApplying: "Wird gespeichert…",
        previewApplied: "Deine Portion ist jetzt {{servings}} Portionen.",
        previewAppliedOne: "Deine Portion ist jetzt 1 Portion.",
        previewApplyError: "Wir konnten diese Portion nicht speichern. Bitte versuche es erneut.",
        previewStale: "Dein Plan hat sich inzwischen geändert. Lade neu, um fortzufahren.",
        previewMaxConflict: "Mit dieser Portion würde dein nächster Einkauf über dein Maximum gehen, deshalb kann sie nicht übernommen werden.",
        blockedTitle: "Diese Portion passt nicht in deinen heutigen Plan",
        blockedAbove: "Damit käme der Tag auf etwa {{actual}} kcal. Dein aktueller Bereich geht bis {{upper}} kcal.",
        blockedBelow: "Damit käme der Tag auf etwa {{actual}} kcal. Dein aktueller Bereich beginnt bei {{lower}} kcal.",
        blockedOther: "Sie würde eine der Regeln verletzen, auf denen dein Plan aufbaut, deshalb kann sie so nicht übernommen werden.",
        blockedHint: "Probiere eine andere Portionsgröße oder bitte Amy, im heutigen Plan Platz zu schaffen.",
        blockedCta: "Amy um Platz bitten",
        blockedPrompt: "Bitte schaff in meinem heutigen Plan Platz, damit ich {{meal}} mit {{servings}} Portionen essen kann — lass diese Mahlzeit so, wie sie ist, und passe etwas anderes heute an.",
        blockedPromptOne: "Bitte schaff in meinem heutigen Plan Platz, damit ich {{meal}} mit 1 Portion essen kann — lass diese Mahlzeit so, wie sie ist, und passe etwas anderes heute an.",
        costUnavailable: "Kostenschätzung nicht verfügbar",
        notFoundTitle: "Diese Mahlzeit konnten wir nicht finden",
        notFoundBody: "Sie wurde möglicherweise getauscht oder aus deinem aktuellen Plan entfernt.",
        // Fresh Adaptive Recipe (ADR-068 production implementation)
        heroActive: "{{minutes}} Min aktiv",
        heroTotal: "{{minutes}} Min gesamt",
        stepperDecrease: "Weniger Portionen",
        stepperIncrease: "Mehr Portionen",
        stepsCount: "{{count}} Schritte",
        stepsCountOne: "1 Schritt",
        stepA11y: "Schritt {{n}}: {{text}}",
        macroKcal: "kcal",
        macroProtein: "Eiweiß",
        macroCarbs: "Kohlenh.",
        macroFat: "Fett",
    },
    pantry: {
        title: "Deine Küche",
        emptyHeroSubhead: "Amy plant mit dem, was du bereits zu Hause hast.",
        scanButton: "Produkt scannen",
        addManuallyButton: "Manuell hinzufügen",
        useSoon: "Bald verwenden",
        scanInstructions: "Richte die Kamera auf den Barcode",
        scanPermissionDeniedTitle: "Kamerazugriff erforderlich",
        scanPermissionDeniedBody: "Erlaube den Kamerazugriff, um ein Produkt zu scannen, oder füge es stattdessen manuell hinzu.",
        scanPermissionSettingsButton: "Einstellungen öffnen",
        scanNotFoundTitle: "Produkt konnte nicht erkannt werden",
        scanNotFoundBody: "Füge es stattdessen manuell hinzu — das dauert nur einen Moment.",
        scanErrorBody: "Beim Scannen ist etwas schiefgelaufen. Versuch es erneut oder füge das Produkt manuell hinzu.",
        scanFoundTitle: "Produkt gefunden",
        scanTryAgain: "Erneut versuchen",
        manualEntryTitle: "Manuell hinzufügen",
        manualModeStructured: "Schnell hinzufügen",
        manualModeFreeText: "Liste eingeben",
        nameLabel: "Artikel",
        namePlaceholder: "z. B. Eier",
        expiryOptionalLabel: "Ablaufdatum (optional)",
        addExpiryButton: "Ablaufdatum hinzufügen",
        manualEntrySubmit: "Hinzufügen",
        amyNoticedEyebrow: "Amy hat bemerkt",
        amyNoticedDisplayOne: "Du hast bereits {{items}}. Soll ich den Rest dieser Woche darum herum planen?",
        amyNoticedDisplayMany: "Du hast bereits {{items}}. Soll ich den Rest dieser Woche darum herum planen?",
        amyNoticedChatPrompt: "Plane den Rest dieser Woche rund um das, was in meiner Küche ist: {{items}}.",
        askAmyKitchenPrompt: "Möchtest du Hilfe, um das zu nutzen, was du schon hast?",
        optInTitle: "Vorräte zu Hause erfassen?",
        optInBody: "Sag BiteBalance, was du schon hast — jeder Plan baut darauf auf: kleinere Einkaufslisten, weniger Verschwendung, geringere Kosten.",
        optInBody2: "Tippe ein, was du hast — eine kurze Liste reicht.",
        optInCta: "Küche aktivieren",
        optInLater: "Vielleicht später",
        optInWorksNote: "Dein Wochenplan und deine Einkaufsliste funktionieren auch ohne — deine Küche macht sie nur günstiger.",
        savedLine: "Deine Küche hat diese Woche {{amount}} gespart",
        quantityLabel: "Menge",
        uncertainPrefix: "etwa",
        expiryLabel: "Haltbar bis {{date}}",
        quickAddLabel: "Artikel per Text hinzufügen",
        quickAddPlaceholder: "z. B. 6 Eier und 300 g Reis",
        extractButton: "Artikel erkennen",
        extracting: "Wird erkannt…",
        candidatesTitle: "Bestätige, was wir gefunden haben",
        candidatesBody: "Prüfe Namen, Mengen und Einheiten, bevor du sie zu deiner Küche hinzufügst.",
        matchedLabel: "Zugeordnet",
        unmatchedLabel: "Braucht deine Bestätigung — keine Katalogzuordnung",
        unmatchedSkipped: "{{count}} Artikel konnten nicht zugeordnet werden und wurden nicht hinzugefügt — versuch einen genaueren Namen, z. B. 'weißer Reis'.",
        didYouMean: "Meintest du:",
        notInCatalogTitle: "Noch nicht im BiteBalance-Katalog",
        notInCatalogBody: "Dieser Artikel kann nicht automatisch hinzugefügt werden.",
        backToKitchen: "Zurück zur Küche",
        // Barcode-Zustandsmaschine (Founder-QA 2026-09-14) — eine Zeile pro sichtbarem Zustand.
        uncertainTitle: "Wir glauben, das ist {{name}}",
        uncertainAsk: "Stimmt das?",
        uncertainConfirm: "Ja, das stimmt",
        notInCatalogFound: "Wir haben \u201E{{product}}\u201C gefunden, aber es ist noch nicht im BiteBalance-Lebensmittelkatalog.",
        scanAnother: "Anderes Produkt scannen",
        quantityUnknownNote: "Wir konnten die Packungsgröße nicht lesen \u2014 prüf die Menge.",
        quantityInvalid: "Gib eine Menge größer als 0 ein.",
        lookupFailedTitle: "Wir konnten dieses Produkt nicht nachschlagen",
        lookupFailedBody: "Prüf deine Verbindung und versuch es erneut.",
        saveFailedTitle: "Wir konnten dieses Produkt nicht speichern",
        confidenceLabel: "{{percent}}% Übereinstimmung",
        confirmButton: "Zur Küche hinzufügen",
        confirming: "Wird hinzugefügt…",
        cancelButton: "Verwerfen",
        confirmedSuccess: "Zu deiner Küche hinzugefügt.",
        confirmError: "Wir konnten diese Artikel nicht speichern. Bitte versuche es erneut.",
        emptyTitle: "Deine Küche ist leer",
        emptyBody: "Füge oben per Textfeld hinzu, was du hast — BiteBalance nutzt es dann in deinem Plan.",
        educationTitle: "Warum deine Küche zählt",
        educationBody: "Amy plant mit dem, was du schon zu Hause hast, deine Einkaufsliste zieht es automatisch ab, und markierte Mahlzeiten halten alles für dich aktuell — weniger Verschwendung und eine kleinere Einkaufsrechnung.",
        educationDismiss: "Alles klar",
        educationShow: "Warum ist das wichtig?",
        editButton: "Bearbeiten",
        editQuantityLabel: "Neue Menge ({{unit}})",
        editSave: "Menge speichern",
        editSaving: "Wird gespeichert…",
        editCancel: "Abbrechen",
        editError: "Wir konnten diesen Artikel nicht aktualisieren. Bitte versuche es erneut.",
        removeButton: "Entfernen",
        removing: "Wird entfernt…",
        removeError: "Wir konnten diesen Artikel nicht entfernen. Bitte versuche es erneut.",
        updatedSuccess: "Küche aktualisiert.",
        headerEyebrow: "Was du schon hast",
        headerTitle: "Deine Küche",
        sectUseBy: "Haltbar bis",
        sectStock: "Vorrätig",
        sectBought: "Gerade gekauft",
        sectCooked: "Gekocht und wartet",
        useToday: "Heute verbrauchen",
        useTomorrow: "Morgen verbrauchen",
        daysLeft: "{{count}} Tage",
        usesOne: "1 Mahlzeit nutzt es",
        usesMany: "{{count}} Mahlzeiten nutzen es",
        boughtSub: "Vom Einkauf · jetzt verfügbar",
        expiringLabel: "Läuft ab",
        expiringOne: "läuft {{when}} ab und steckt in einer geplanten Mahlzeit vorher. Nichts zu tun.",
        expiringMany: "läuft {{when}} ab und steckt in {{count}} geplanten Mahlzeiten vorher. Nichts zu tun.",
        whenToday: "heute",
        whenTomorrow: "morgen",
        rowHint: "Menge anpassen oder entfernen",
        stepDownA11y: "{{step}} weniger",
        stepUpA11y: "{{step}} mehr",
        unitCount: "Stk.",
    },
    shop: {
        budgetUnverifiable: "Der Großteil der Woche ist bepreist, aber {{count}} Artikel haben noch keinen verlässlichen Preis — wir können nicht bestätigen, dass der Plan unter deinem Budget von {{budget}} liegt.",
        buyLine: "{{qty}} kaufen",
        pantryCovers: "Deine Küche deckt es ab — nichts kaufen",
        priceMix: "{{real}} echte Preise · {{est}} Schätzungen",
        weekEyebrow: "Geschätzt",
        weekHeadline: "Diese Woche ≈ {{amount}}",
        weekHeadlineBudget: "Diese Woche ≈ {{amount}} · Budget {{budget}}",
        weekHeadlineOverBudget: "Diese Woche ≈ {{amount}} · {{delta}} über Budget",
        weekCheckoutLine: "Einkauf in ganzen Packungen ≈ {{amount}} · Reste bleiben in deiner Küche",
        budgetOver: "≈ {{over}} über deinem Wochenbudget von {{budget}}",
        budgetTrim: "Amy bitten zu sparen",
        detailsA11y: "Rechnung zu diesem Artikel anzeigen",
        tabPantry: "Küche",
        tabShopping: "Einkaufsliste",
        pantryLink: "Du suchst deine Küche? Verwalte sie auf der Küche-Seite.",
        requiredLabel: "Benötigt",
        reservedLabel: "Aus deiner Küche",
        netLabel: "Netto benötigt",
        packLabel: "Packung",
        buyLabel: "Kaufen",
        leftoverLabel: "Rest",
        sourceMealsLabel: "Verwendet in {{count}} Mahlzeiten",
        // WS3 Shop → Pantry v1: per-row purchase confirmation + "Shop done".
        purchaseTitle: "Was ist mitgekommen?",
        purchaseHint: "Sag es pro Artikel — nur was du bestätigst, landet in deiner Küche. Prognostizierte Reste nie.",
        purchaseBought: "Gekauft",
        purchaseAlreadyHad: "Hatte ich schon",
        purchaseNotBought: "Nicht gekauft",
        purchaseStateBought: "Gekauft · {{qty}} in deiner Küche",
        purchaseStateAlreadyHad: "Hatte ich schon · {{qty}} zur Küche hinzugefügt",
        purchaseStateAlreadyHadNone: "Hatte ich schon — nichts zur Küche hinzugefügt",
        purchaseStateNotBought: "Nicht gekauft — nichts in deiner Küche",
        purchaseStateA11y: "Kaufstatus für {{name}}",
        purchaseQtyLabel: "Mitgekommene Menge ({{unit}})",
        purchaseQtySave: "Menge aktualisieren",
        shopDoneButton: "Einkauf erledigt",
        shopDoneHint: "Markiert jeden offenen Artikel als gekauft in der gelisteten Menge. Du kannst jeden Artikel danach korrigieren.",
        shopDoneAllResolved: "Alle Artikel sind bestätigt.",
        purchaseSynced: "Küche aktualisiert: {{added}} Artikel hinzugefügt, {{adjusted}} korrigiert.",
        purchaseSyncedNone: "Gespeichert — in deiner Küche hat sich nichts geändert.",
        purchaseError: "Wir konnten deinen Einkauf nicht speichern. Bitte versuche es erneut.",
        manualBadge: "Von dir hinzugefügt",
        listTotalLabel: "Geschätzte Summe",
        addManualTitle: "Artikel hinzufügen",
        addManualName: "Artikelname",
        addManualQty: "Menge (optional)",
        addManualButton: "Artikel hinzufügen",
        exportButton: "Liste kopieren",
        exportCopied: "Liste kopiert — füge sie in die App deines Händlers ein.",
        exportShared: "Liste geteilt.",
        exportRetailerLine: "Funktioniert mit REWE, EDEKA, Lidl und mehr — einfach in jede Einkaufs-App einfügen.",
        emptyTitle: "Deine Einkaufsliste ist leer",
        emptyBody: "Sobald du einen Plan hast, erscheint hier alles, was du kaufen musst.",
        offerBadge: "Angebot",
        offerChipValidUntil: "bis {{date}}",
        offerChipAria: "Angebot bei {{retailer}}: {{price}}, gültig bis {{date}} — Kann je nach Markt abweichen",
        offerPackagePriceLabel: "Angebotspreis (pro Packung, nicht pro Portion): {{price}}",
        offerUnitPrice: "{{price}} pro {{unit}}",
        offerSourceLine: "Quelle: {{source}}, erfasst am {{date}}",
        offerMayVary: "Kann je nach Markt abweichen",
        unpricedNote: "{{count}} Artikel ohne Preis",
        costDisclosure: "Kosten und Budget",
        costDisclosureHint: "Die Schätzung für diese Liste, die Kassenbewertung und dein Wochenziel",
        priceUnavailable: "Preis nicht verfügbar",
        realPriceBadge: "Aktuell",
        // Fresh Adaptive Shop (ADR-068): the precise list's title, its derived groups and the Shop → Kitchen thread.
        screenTitle: "Einkauf",
        groupToBuy: "Zu kaufen",
        groupCovered: "Deine Küche deckt es ab",
        allTickedLabel: "Alles eingekauft",
        kitchenUpdatedLabel: "Küche auf Stand",
        toKitchen: "Zur Küche",
        // Shop list clarity (2026-10-06): the need beside the pack bought, the supermarket sections, the words for a counted unit and a pack.
        needLine: "Bedarf {{need}}",
        needLineRemaining: "Noch {{need}} nötig",
        decimalMark: ",",
        section: {
            produce: "Obst & Gemüse",
            chilled: "Kühlregal",
            meat_fish: "Fleisch & Fisch",
            frozen: "Tiefkühl",
            dry_goods: "Trockenware & Vorräte",
            spices_oils: "Gewürze & Öle",
            drinks: "Getränke",
            other: "Sonstiges",
        },
        countNoun: { pieceOne: "Stück", pieceMany: "Stück", cloveOne: "Zehe", cloveMany: "Zehen" },
        packNoun: { bulbOne: "Knolle", bulbMany: "Knollen", netOne: "Netz", netMany: "Netze", packOne: "Packung", packMany: "Packungen" },
    },
    // Budget-Modell v2 (ADR-052). Metrik-NAMEN und Definitionen kommen aus dem
    // kanonischen Glossar (glossary.ts) — hier nur die umgebenden UI-Texte.
    budget: {
        spendingDisclosure: "Deine Lebensmittelausgaben",
        sectionTitle: "Lebensmittelbudget",
        perWeek: "/ Woche",
        optional: "Optional",
        remove: "Entfernen",
        noGoalSet: "Kein Ausgabenziel gesetzt",
        noMaxSet: "Kein Maximum gesetzt",
        invalidAmount: "Gib einen gültigen Betrag ein, z. B. 45 oder 45,50.",
        saved: "Budget gespeichert.",
        outlookTitle: "Dein Budget-Ausblick",
        outlookBasis: "Schätzung aus dem Plan dieser Woche — keine tatsächlichen Ausgaben.",
        weeklyGoalRow: "Wochenziel",
        differenceRow: "Differenz",
        notTrackedYet: "Noch nicht erfasst",
        notTrackedHint: "BiteBalance erfasst noch nicht, was du bezahlst. Echte Einkäufe erfassen ist für ein späteres Update geplant.",
        cantConfirm: "Noch nicht bestätigbar — {{count}} Artikel ohne verlässlichen Preis",
        noPlanYet: "Dein Ausblick erscheint, sobald du einen Plan hast.",
        setupTitle: "Richte dein Lebensmittelbudget ein",
        setupBody: "Du hattest ein Wochenbudget von {{amount}} festgelegt. BiteBalance unterscheidet jetzt zwischen deinem durchschnittlichen wöchentlichen Ausgabenziel und einer optionalen Grenze für einen einzelnen Einkauf.",
        setupGoalHelper: "Wie viel du im Durchschnitt pro Woche für Lebensmittel ausgeben möchtest.",
        setupNoGoal: "Ich möchte kein wöchentliches Ausgabenziel",
        setupMaxToggle: "Ein Maximum für einen Einkauf festlegen",
        setupMaxHelper: "Der höchste Betrag, den du bei einem einzelnen Einkauf ausgeben willst.",
        setupSave: "Budget speichern",
        setupNothingChosen: "Wähle ein wöchentliches Ausgabenziel, ein Maximum für einen Einkauf oder beides.",
        setupSaved: "Dein Budget ist eingerichtet.",
        legacyLater: "Später entscheiden",
        pendingNoticeTitle: "Dein bisheriges Budget von {{amount}} begrenzt weiterhin jeden Einkauf.",
        pendingNoticeBody: "Richte deine neuen Budget-Optionen ein, wann immer du bereit bist.",
        pendingNoticeCta: "Einrichten",
        previousBudgetLabel: "Dein bisheriges Budget · {{amount}}/Woche",
        previousBudgetHint: "Bis du diese Einstellung aktualisierst, behandelt BiteBalance {{amount}} weiterhin als Grenze für jeden einzelnen Einkauf.",
        todayTransitionTitle: "Wähle, wie dein Budget von {{amount}} funktionieren soll",
        todayTransitionBody: "Dein bisheriges Budget von {{amount}} begrenzt weiterhin jeden Einkauf, bis du dein neues wöchentliches Ausgabenziel und ein optionales Einkaufsmaximum einrichtest.",
        todayTransitionCta: "Budget einrichten",
        staleSettingsTitle: "Dein Plan wurde mit früheren Einstellungen erstellt",
        staleSettingsBody: "Deine Budget-Einstellungen haben sich geändert, seit dieser Plan erstellt wurde. Erstelle die Woche neu, wann immer du bereit bist.",
        staleSettingsCta: "Plan neu erstellen",
        candidateNote: "Das ist die günstigste Alternative, die BiteBalance bei diesem Neuaufbau gefunden hat — nicht deine aktuelle Einkaufsliste.",
        pricedSoFar: "Bisher bepreist",
        needsPriceCount: "{{count}} Artikel brauchen noch einen verlässlichen Preis",
        // Shop headline (2026-10-06): the figure is the checkout price of WHOLE PACKS, not the value of the food eaten.
        // The complete estimate may say "total" in EN (founder 2026-10-06); the German label stays without "Summe"/"gesamt".
        completeEstimateLabel: "Einkauf, ganze Packungen · geschätzt",
        liveEstimateLabel: "Schätzung mit heutigen Preisen und deiner Küche",
        liveEstimateNote: "Neu berechnet aus deiner aktuellen Küche und aktuellen Preisen — kann von der Liste unten abweichen.",
        partialEconomicsNote: "Die Aufteilung in verbrauchte Lebensmittel und das, was bleibt, erscheint, sobald jeder Artikel einen verlässlichen Preis hat.",
        shopCheckoutTitle: "Dieser Einkauf",
        shopWithinMax: "≈ {{cost}} — {{under}} unter deinem Maximum von {{max}}",
        shopExceedsMax: "≈ {{cost}} — {{over}} über deinem Maximum von {{max}}. Ändere oder entferne das Maximum in den Einstellungen.",
        shopUnverifiableMax: "{{count}} Artikel haben noch keinen verlässlichen Preis — wir können nicht bestätigen, dass dieser Einkauf unter deinem Maximum von {{max}} bleibt.",
        shopGoalLine: "Voraussichtlicher Wochendurchschnitt ≈ {{forecast}} (Schätzung) · Ziel {{goal}} · {{status}}",
        shopGoalUnavailable: "Voraussichtlicher Wochendurchschnitt nicht verfügbar — {{reason}}",
        shopLegacyLimitNote: "Dein bisheriges Budget von {{amount}} begrenzt weiterhin jeden Einkauf. Richte deine neuen Budget-Optionen in den Einstellungen ein.",
        todayLine: "Prognose ≈ {{forecast}}/Woche · {{status}}",
        insightsForecastTitle: "Voraussichtlicher Wochendurchschnitt im Verlauf",
        insightsForecastNote: "Jeder Punkt ist eine Schätzung aus der jeweiligen Planversion — nicht, was du ausgegeben hast.",
        insightsActualTitle: "Tatsächlicher Wochendurchschnitt",
        insightsActualCta: "Erfasse nach dem Einkauf, was du ausgegeben hast — kommt in einem späteren Update.",
        planMaxInfeasibleTitle: "Keine gültige Woche passt unter dein Maximum",
        planMaxInfeasibleBody: "Wir konnten keine Woche bauen, deren Einkauf unter {{max}} bleibt — der günstigste gefundene Plan kostet {{cheapest}} an der Kasse ({{over}} darüber). Dein aktueller Plan bleibt unverändert. Erhöhe oder entferne das Maximum in den Einstellungen oder frag Amy nach Optionen.",
        planLegacyInfeasibleBody: "Dein bisheriges Budget von {{max}} begrenzt weiterhin jeden Einkauf — der günstigste gefundene Plan kostet {{cheapest}} an der Kasse ({{over}} darüber). Dein aktueller Plan bleibt unverändert. Richte dein neues wöchentliches Ausgabenziel und ein optionales Einkaufsmaximum in den Einstellungen ein.",
        planMaxInfeasibleCta: "Budget-Einstellungen öffnen",
        planGoalImpact: "Voraussichtlicher Wochendurchschnitt {{before}} → {{after}} · {{status}}",
        planCheckoutConflict: "Diese Änderung bringt den Einkauf dieser Woche etwa {{over}} über dein Maximum von {{max}} und kann deshalb nicht übernommen werden. Ändere oder entferne das Maximum in den Einstellungen.",
        onboardingGoalLabel: "Wöchentliches Ausgabenziel (optional)",
        onboardingGoalHint: "Der Betrag, den deine Lebensmittel im Wochendurchschnitt kosten sollen. Ein Maximum pro Einkauf kannst du später in den Einstellungen festlegen.",
        onboardingSkip: "Vorerst überspringen",
        guideCenterTitle: "Guide Center",
        guideCenterGuides: "Guides",
        guideCenterGuidesSub: "Praktische Texte zu Essen, Gewicht und Gewohnheiten",
        guideCenterGlossary: "Glossar",
        guideCenterGlossarySub: "Was jede Zahl in BiteBalance bedeutet",
        guideCenterBudgetGuide: "So funktioniert dein Lebensmittelbudget",
        guideCenterBudgetGuideSub: "Dein wöchentliches Ausgabenziel, der nächste Einkauf und was übrig bleibt",
        budgetGuideLinkText: "So funktioniert dein Lebensmittelbudget",
        glossaryHubCardTitle: "Glossar",
        glossaryHubCardSubtitle: "Die Begriffe, die BiteBalance für dein Budget, dein Essen und deinen Fortschritt verwendet — einfach erklärt.",
        infoAria: "Was bedeutet {{name}}?",
    },
};
